import React from "react";
import { useFirmwareReleases } from "@/hooks/useFirmwareReleases";
import { ReleaseTable } from "@/components/firmware/ReleaseTable";
import { Loading } from "@/components/common/Loading";

export function AdminFirmware() {
  const { data, isLoading, error } = useFirmwareReleases();

  if (isLoading) return <Loading />;
  if (error) return <p className="text-danger-text">Could not load firmware releases.</p>;

  return (
    <div className="space-y-md">
      <header className="space-y-xs">
        <h1 className="text-xl font-semibold">Firmware releases</h1>
        <p className="text-textLight text-sm">
          To publish a new release: upload the binary with{" "}
          <code className="px-xs py-[1px] bg-bg rounded-sm">gsutil cp …</code>{" "}
          to <code className="px-xs py-[1px] bg-bg rounded-sm">gs://talis-kraken-firmware/</code>,
          then call{" "}
          <code className="px-xs py-[1px] bg-bg rounded-sm">POST /api/admin/firmware/release</code>{" "}
          with the version + sha256 + gcs_object. Toggle the published state below.
        </p>
      </header>
      <ReleaseTable releases={data?.releases ?? []} />
    </div>
  );
}
